<template>
  <error v-if="error" :error="error" />    
    <div id="basic-info" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('settings.Studebook_status_info') }}</h5>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-4">
              <div class="input-group input-group-static null">
              <label>{{ $t('settings.Code') }} *</label>
              <input v-model="state.code" type="text" class="form-control form-control-default" :placeholder="$t('settings.Code')">
              <span v-if="v$.code.$error" class="text-sm text-danger">
                  {{ v$.code.$errors[0].$message }}
              </span>
              </div>
          </div>
          <div class="col-8">
              <div class="input-group input-group-static null">
              <label>{{ $t('settings.Description') }} *</label>
              <input v-model="state.description" type="text" class="form-control form-control-default" :placeholder="$t('settings.Description')">
              <span v-if="v$.description.$error" class="text-sm text-danger">
                  {{ v$.description.$errors[0].$message }}
              </span>
              </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-2">
              <div class="input-group input-group-static null">
                <label>{{ $t('settings.Section_code') }} *</label>
                <input v-model="state.sectionCode" type="text" class="form-control form-control-default" :placeholder="$t('settings.Section_code')">
                <span v-if="v$.sectionCode.$error" class="text-sm text-danger">
                    {{ v$.sectionCode.$errors[0].$message }}
                </span>
                </div>
            </div>
            <div class="col-5">
                <div class="input-group input-group-static null">
                <label>{{ $t('settings.Section') }} *</label>
                <input v-model="state.section" type="text" class="form-control form-control-default" :placeholder="$t('settings.Section')">
                <span v-if="v$.section.$error" class="text-sm text-danger">
                    {{ v$.section.$errors[0].$message }}
                </span>
                </div>
            </div>
            <div class="col-5">
                <div class="input-group input-group-static null">
                <label>{{ $t('settings.Section_classification') }} *</label>
                <input v-model="state.sectionClassification" type="text" class="form-control form-control-default" :placeholder="$t('settings.Section_classification')">
                <span v-if="v$.sectionClassification.$error" class="text-sm text-danger">
                    {{ v$.sectionClassification.$errors[0].$message }}
                </span>
                </div>
            </div>
        </div>
        <div class="row mt-4">
          <div class="col-6" v-if="['Admin'].includes(userRoleName)">
            <div class="input-group input-group-static null">
              <label>{{ $t('settings.Association') }} *</label>  
              <select id="associationId" v-model="state.associationId" class="form-control form-control-default">
                  <option value="">{{ $t('settings.Select_association') }}</option>         
                  <option v-for="association in state.associations" :key="association.id" :value="association.id">                  
                      {{ association.abbreviation }}
                  </option>                  
              </select>        
              <span v-if="v$.associationId.$error" class="text-sm text-danger">
                  {{ v$.associationId.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div class="col-6">
          </div>
        </div>
        <div class="col-12 col-sm-12 mt-6">                                
          <input type="hidden" v-model="state.id" class="form-control">          
          <router-link to="/settings" class="btn btn-sm bg-gradient-danger float-start">{{ $t('common.Cancel') }}</router-link>
          <button v-on:click="updateStudebookSection" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Update') }}</button>
        </div>        
      </div>
    </div>    
  </template>
  
  <script>
  import * as Choices from "choices.js";  
  import axios from 'axios'
  import useValidate from '@vuelidate/core'
  import { required, helpers, } from '@vuelidate/validators'
  import { reactive, computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { useStore } from 'vuex'
  
  export default {
    name: "StudebookSectionDetail",
    setup() {
        const { t } = useI18n()
        const store = useStore()

        const state = reactive ({            
            studebooksection: [],            
            id: '',            
            code: '',
            description: '',
            sectionCode: '',
            section: '',
            sectionClassification: '',
            associationId: '',
            associations:[],
        })

        const userRoleName = computed(() => store.state.user?.roleName)

        const rules = computed(() => {
            const isAdmin = userRoleName.value === 'Admin';

            return {
                code: { required: helpers.withMessage(t('common.Required'), required) },
                description: { required: helpers.withMessage(t('common.Required'), required) },
                sectionCode: { required: helpers.withMessage(t('common.Required'), required) },
                section: { required: helpers.withMessage(t('common.Required'), required) },
                sectionClassification: { required: helpers.withMessage(t('common.Required'), required) },
                associationId: isAdmin
                ? {
                    required: helpers.withMessage(t('common.Required'), required),
                    isSelected: helpers.withMessage(t('common.Select_an_association'), value => value !== '')
                }
                : {}
            }
        })
        
        const v$ = useValidate(rules, state)

        return {
            state,
            v$,
            userRoleName,
            choicesInstance: null // Store Choices instance
        }
    },    
    components: {      
    },
    data() {
      return {        
        gets: [],
        error: '',        
      };
    },
    async mounted() {  
      this.id = this.$route.params.id;            
      await this.fetchStudebookSectionData(this.$route.params.id);         
    },
    methods: { 
      async fetchAllAssociationData() {
          try {             
              const response = await axios.get("Association/getall");
              const result = response.data;

              if (result.success && Array.isArray(result.data.associationList)) {
                  this.state.associations = result.data.associationList;

                  this.$nextTick(() => {
                      this.initializeChoices();
                  });                    
              } else {
                this.$showError('errors.Error_fetching_association');
              }
          } catch (e) {
              const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
              this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
      },      
      initializeChoices() {
          const element = document.getElementById("associationId");
          if (this.choicesInstance) {
              this.choicesInstance.destroy(); // Clean up previous instance
          }

          this.choicesInstance = new Choices(element, {
              searchEnabled: true,
              shouldSort: false,
              placeholder: true, 
              //placeholderValue: '-- Select association --', 
          });

          // Set the dropdown options
          if (Array.isArray(this.state.associations) && this.state.associations.length > 0) {
              // Check if the registerId exists among the registers
              if (this.state.associationId) {
                  const optionExists = this.state.associations.some(x => x.id === this.state.associationId);
                  if (optionExists) {
                      this.choicesInstance.setChoiceByValue([this.state.associationId]); // Set the selected value
                  } else {
                      this.choicesInstance.setChoiceByValue(''); // Clear if no match found
                  }
              }
          }

          // Listen for changes and update state
          element.addEventListener('change', (event) => {
              this.state.registerId = event.target.value; // Update the state
              this.v$.$validate(); // Trigger validation
          });
      },

      async fetchStudebookSectionData(studebookSectionId) {
        try {            
            this.$store.commit('setShowLoading', true);

            const response = await axios.get(`StudebookSection/${studebookSectionId}`);
            this.gets = response.data;

            if (this.gets.success) {
                this.state.studebookstatus = this.gets.data;
                this.state.id = this.state.studebookstatus.id;                
                this.state.associationId = this.state.studebookstatus.associationId;
                this.state.code = this.state.studebookstatus.code;
                this.state.description = this.state.studebookstatus.description;
                this.state.sectionCode = this.state.studebookstatus.sectionCode;
                this.state.section = this.state.studebookstatus.section;
                this.state.sectionClassification = this.state.studebookstatus.sectionClassification;

                if (this.userRoleName === 'Admin') {
                    await this.fetchAllAssociationData();
                }
            } else {
                this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
        
        this.$store.commit('setShowLoading', false);
      },
      async updateStudebookSection() {   
            try {
                this.$store.commit('setShowLoading', true);

                this.v$.$validate();                
                console.log(this.v$.$error);

                if(!this.v$.$error) {
                    const formData = {
                        id: this.state.id,
                        code: this.state.code,
                        description: this.state.description,
                        sectionCode: this.state.sectionCode,
                        section: this.state.section,
                        sectionClassification: this.state.sectionClassification,
                        associationId: this.userRoleName === 'Admin'
                            ? this.state.associationId
                            : this.$store.state.associationAdminAssociationId,
                        rvoRecognized: this.state.rvoRecognized
                    };
                    const response = await axios.put('StudebookSection/update', formData);
                    this.gets = response.data;

                    if (this.gets.success) {

                      this.$showSuccess('errors.Success_studebook_status_updated_successfully');
                      
                      this.$router.push('/settings');
                    } else {
                        this.$showError('errors.Contact_system_admin');
                    }
                }                
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {                       
              this.$store.commit('setShowLoading', false);
            }
      },
    }
  };
</script>  
<style>
.choices {
  margin-bottom: 0px !important;
}
</style>